import React from 'react';
import { styled } from '@mui/material/styles';
import Box, { BoxProps } from '@mui/material/Box';

type Props = {
  children: React.ReactNode;
  smPaddings?: boolean;
} & BoxProps

const ContainerStyled = styled(Box, {
  shouldForwardProp: (propName: PropertyKey) => propName !== 'smPaddings'
})<Props>(({ theme, smPaddings }) => {
  const minDesktopSize = theme.breakpoints.values.lg + 1;
  const isMinDesktop = theme.breakpoints.up(minDesktopSize);

  return {
    [theme.breakpoints.up('xs')]: {
      marginTop: '30px',
      marginBottom: '30px',
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(4),
      marginBottom: '60px',
    },
    [isMinDesktop]: {
      marginTop: smPaddings ? '40px' : '100px',
      marginBottom: smPaddings ? '60px' : '80px',
    },
  };
});

function Container({ children, ...props }: Props) {
  return (
    <ContainerStyled {...props}>{children}</ContainerStyled>
  );
}

export default Container;
